import React from "react";
import Rightaside from "../reusable/Rightaside";
import {
  ABOUT_ASIDE,
  ABOUT_HERO,
  ABOUT_CARDS,
  ABOUT_MISSION,
  ABOUT_BOTTOM_CONTENT,
} from "../utils/constants";
import { WHY_CHOOSE_US } from "../utils/constants";
import LeftAside from "../reusable/Leftaside";
import AboutCard from "../reusable/AboutCard";
import PageDesc from "../reusable/PageDesc";
import "../Styles/about.css";

const AboutUs = () => {
  return (
    <div className="outlet-render">
      <Rightaside {...ABOUT_HERO} />
      <PageDesc {...ABOUT_MISSION} />
      <LeftAside {...ABOUT_ASIDE} />
      <div className="about-cards-main">
        <h1 className="why-choose-us">{WHY_CHOOSE_US}</h1>
        <div className="about-card-container">
          {ABOUT_CARDS.map((item) => {
            return <AboutCard {...item} />;
          })}
        </div>
      </div>

      <PageDesc {...ABOUT_BOTTOM_CONTENT} />
    </div>
  );
};

export default AboutUs;
